import { Suspense, lazy, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Loading from "./components/Loading";

const Builder = lazy(() => import("./pages/commons/BUILDER"));
const BuilderVisio = lazy(() => import("./pages/commons/BUILDER_VISIO"));
const BuilderResidentiel = lazy(() => import("./pages/commons/BUILDER_RESIDENTIEL"));
const WhoAreYou = lazy(() => import("./pages/commons/WHOAREYOU"));
const AUTO_GEO_REDIRECT = lazy(() => import("./components/AutoGeoLocation"));

const Checkout = lazy(() => import("./components/Checkout"));
const CheckoutCancel = lazy(() => import("./components/Checkout/Cancel"));
const CheckoutSuccess = lazy(() => import("./components/Checkout/Success"));
const CheckoutSuccessResidentiel = lazy(() => import("./components/Checkout/SuccessResidentiel"));

const sourceParam = new URLSearchParams(window.location.search).get('source');
if (sourceParam) { localStorage.setItem('source', decodeURIComponent(sourceParam)); }
const gclidParam = new URLSearchParams(window.location.search).get('gclid');
if (gclidParam) { localStorage.setItem('gclid', gclidParam); }
const firstVisitedPageParam = new URLSearchParams(window.location.search).get('first_visited_page');
if (firstVisitedPageParam) { localStorage.setItem('first_visited_page', decodeURIComponent(firstVisitedPageParam)); }
const referrerPageParam = new URLSearchParams(window.location.search).get('referrer_page');
if (referrerPageParam) { localStorage.setItem('referrer_page', decodeURIComponent(referrerPageParam)); }
if (window !== window.parent) {
  window.parent.postMessage({ type: 'getHistory' }, 'https://sarahnacass.com/');
  window.addEventListener('message', (event) => {
    if (event.origin !== 'https://sarahnacass.com/') return;
    if (event.data.type === 'historyData') {
      const linksHistory = event.data.data
      localStorage.setItem('links_history', JSON.stringify(linksHistory));
    }
  });
}

// Récupérer le Client ID de GA4
const getClientIdFromCookie = () => {
  const gaCookie = document.cookie.split(";").find((cookie) => cookie.trim().startsWith("_ga="));
  if (!gaCookie) return null;

  const gaValue = gaCookie.split("=")[1];
  const clientId = gaValue.replace(/^GA\d+\.\d+\./, "");
  return clientId;
};

export default function App() {

  // Stocker et envoyer le Client ID de GA4
  useEffect(() => {
    const interval = setInterval(() => {
      const clientId = getClientIdFromCookie();
      if (clientId) {
        localStorage.setItem("cid", clientId);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "initialisation",
          client_id: clientId
        });
        clearInterval(interval);
      }
    }, 500);
    return () => clearInterval(interval);
  }, []);

  return <Suspense fallback={<Loading />}>
    <BrowserRouter>
      <Routes>
        {/* NOT FOUNDED PAGE OR ROOT PAGE ! */}
        <Route exact path="/" element={<WhoAreYou />} />
        <Route path="*" element={<WhoAreYou />} />

        {/* Visio */}
        <Route path="/visio" element={<BuilderVisio resolve="/ue/visio-formation" />} />
        <Route path="/fr/visio" element={<BuilderVisio resolve="/ue/visio-formation" />} />
        <Route path="/be/visio" element={<BuilderVisio resolve="/ue/visio-formation" />} />
        <Route path="/ma/visio" element={<BuilderVisio resolve="/ma/visio-formation" />} />
        <Route path="/ca/visio" element={<BuilderVisio resolve="/ca/visio-formation" />} />
        <Route path="/ch/visio" element={<BuilderVisio resolve="/ue/visio-formation" />} />
        <Route path="/lu/visio" element={<BuilderVisio resolve="/ue/visio-formation" />} />
        <Route path="/mc/visio" element={<BuilderVisio resolve="/ue/visio-formation" />} />
        <Route path="/te/visio" element={<BuilderVisio resolve="/te/visio-formation" />} />

        {/* Geolocalisation */}
        <Route path="/use-auto-locate" element={<AUTO_GEO_REDIRECT />} />

        {/* Paiement */}
        <Route path="/checkout">
          <Route index element={<Checkout />} />
          <Route path="success" element={<CheckoutSuccess />} />
          <Route path="residentiel/success" element={<CheckoutSuccessResidentiel />} />
          <Route path="cancel" element={<CheckoutCancel />} />
        </Route>

        {/* Sur place */}
        <Route path="/fr/sarahnacass">
          <Route path="/fr/sarahnacass/auvergne-rhone-alpes" element={<Builder resolve="/fr/sarahnacass/auvergne-rhone-alpes" resolveVisio="/ue/visio" />} />
          <Route path="/fr/sarahnacass/bourgogne-franche-comte" element={<Builder resolve="/fr/sarahnacass/bourgogne-franche-comte" resolveVisio="/ue/visio" />} />
          <Route path="/fr/sarahnacass/bretagne" element={<Builder resolve="/fr/sarahnacass/bretagne" resolveVisio="/ue/visio" />} />
          <Route path="/fr/sarahnacass/centre-val-de-loire" element={<Builder resolve="/fr/sarahnacass/centre-val-de-loire" resolveVisio="/ue/visio" />} />
          <Route path="/fr/sarahnacass/corse" element={<Builder resolve="/fr/sarahnacass/corse" resolveVisio="/ue/visio" />} />
          <Route path="/fr/sarahnacass/grand-est" element={<Builder resolve="/fr/sarahnacass/grand-est" resolveVisio="/ue/visio" />} />
          <Route path="/fr/sarahnacass/hauts-de-france" element={<Builder resolve="/fr/sarahnacass/hauts-de-france" resolveVisio="/ue/visio" />} />
          <Route path="/fr/sarahnacass/ile-de-france" element={<Builder resolve="/fr/sarahnacass/ile-de-france" resolveVisio="/ue/visio" />} />
          <Route path="/fr/sarahnacass/normandie" element={<Builder resolve="/fr/sarahnacass/normandie" resolveVisio="/ue/visio" />} />
          <Route path="/fr/sarahnacass/nouvelle-aquitaine" element={<Builder resolve="/fr/sarahnacass/nouvelle-aquitaine" resolveVisio="/ue/visio" />} />
          <Route path="/fr/sarahnacass/occitanie" element={<Builder resolve="/fr/sarahnacass/occitanie" resolveVisio="/ue/visio" />} />
          <Route path="/fr/sarahnacass/pays-de-la-loire" element={<Builder resolve="/fr/sarahnacass/pays-de-la-loire" resolveVisio="/ue/visio" />} />
          <Route path="/fr/sarahnacass/provence-alpes-cote-d-azur" element={<Builder resolve="/fr/sarahnacass/provence-alpes-cote-d-azur" resolveVisio="/ue/visio" />} />
          <Route path="/fr/sarahnacass/dom-tom" element={<Builder resolve="/fr/sarahnacass/dom-tom" resolveVisio="/ue/visio" />} />
        </Route>
        <Route path="/be/sarahnacass/belgique" element={<Builder resolve="/be/sarahnacass/belgique" resolveVisio="/ue/visio" />} />
        <Route path="/ma/sarahnacass/maroc" element={<Builder resolve="/ma/sarahnacass/maroc" resolveVisio="/ma/visio" />} />
        <Route path="/ca/sarahnacass/canada" element={<Builder resolve="/ca/sarahnacass/canada" resolveVisio="/ca/visio" />} />
        <Route path="/ch/sarahnacass/suisse" element={<Builder resolve="/ch/sarahnacass/suisse" resolveVisio="/ue/visio" />} />
        <Route path="/lu/sarahnacass/luxembourg" element={<Builder resolve="/lu/sarahnacass/luxembourg" resolveVisio="/ue/visio" />} />
        <Route path="/mc/sarahnacass/monaco" element={<Builder resolve="/mc/sarahnacass/monaco" resolveVisio="/ue/visio" />} />

        {/* Residentiel */}
        <Route path="/fr/residentiel" element={<BuilderResidentiel resolve="/fr/residentiel" />} />
        <Route path="/be/residentiel" element={<BuilderResidentiel resolve="/be/residentiel" />} />
        <Route path="/ma/residentiel" element={<BuilderResidentiel resolve="/ma/residentiel" />} />
        <Route path="/ca/residentiel" element={<BuilderResidentiel resolve="/ca/residentiel" />} />
        <Route path="/ch/residentiel" element={<BuilderResidentiel resolve="/ch/residentiel" />} />
        <Route path="/lu/residentiel" element={<BuilderResidentiel resolve="/lu/residentiel" />} />
        <Route path="/mc/residentiel" element={<BuilderResidentiel resolve="/mc/residentiel" />} />

      </Routes>
    </BrowserRouter>
  </Suspense>
}